import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownOutlinedIcon from "@mui/icons-material/KeyboardDoubleArrowDownOutlined";
import MiddleEllipsis from "react-middle-ellipsis";
import EnterAmountBox from "../../EnterAmountBox";
import { handleAmountChangeCommon } from "../../constants";
import { enterAmount, payToTxt } from "../../messages";
import CommonDrawer from "../../drawer/CommonDrawer";
import Text from "../../text/Text";
import useSendButtonCalculation from "../../../hooks/useSendButtonCalculation";
import Button from "../../button/Button";

function EnterAmountMiniApp({
  isOpen,
  setIsOpen,
  currencyFromDecode,
  data,
  amount,
  setAmount,
  balance,
  networkFeeAmount,
  calculatedSpeedFees,
  isLnUrlMethodReceive,
  isLnUrlMethodSend,
  isEthereumMethod,
  isTronMethod,
  isLightningMethod,
  isOnchainMethod,
  minTransactionAmt,
  maxTransactionAmt,
  sendMaxAmount,
  setWithdrawModal,
  exchangeRate,
}) {
  const [checkExchange, setCheckExchange] = useState(false);
  const [currentAmount, setCurrentAmount] = useState(null);
  const [currentConvertedAmount, setCurrentConvertedAmount] = useState(null);
  const { taprootAsset, showBtcAmount } = useSelector((state) => state.common);

  useEffect(() => {
    setCurrentAmount(amount);
  }, [amount]);

  const handleChangeCurrency = () => {
    setCheckExchange(!checkExchange);
  };

  const handleDrawerClose = () => {
    setIsOpen(false);
    setWithdrawModal(false);
  };

  const handleAmountChange = (e) => {
    const mainAmount = e.target.value;
    // const amount = showBtcAmount ? mainAmount?.slice(0, 10) : mainAmount;

    handleAmountChangeCommon(
      mainAmount,
      checkExchange,
      exchangeRate,
      currencyFromDecode,
      setCurrentAmount,
      setCurrentConvertedAmount
    );

    // taprootAsset?.uuid === sats &&
    //   setIsLargeAmount(satsToBtcAmount(amount) > 5);
  };

  const displayAddress = useMemo(() => {
    return ` ${data?.withdraw_request}`;
    // if (isLnUrlMethodSend) {
    //   return (
    //     <Box display="flex" gap="5px">
    //       <Text className="grey-text" font="regular" size="14">
    //         Pay to{" "}
    //       </Text>

    //       <Text
    //         className="default-text"
    //         font="semibold"
    //         size="14"
    //         sx={{
    //           width: "300px",
    //           whiteSpace: "nowrap",
    //           // textAlign: "center",
    //         }}
    //       >
    //         {data?.payee}
    //       </Text>
    //     </Box>
    //   );
    // } else if (isLnUrlMethodReceive) {
    //   return data?.payee !== ""
    //     ? `Redeem from ${data?.payee}`
    //     : data?.withdraw_request;
    // } else {
    //   return data?.withdraw_request;
    // }
  }, [data]);

  const enterAmountBoxProps = {
    checkExchange,
    currentAmount,
    currentConvertedAmount,
    currency: currencyFromDecode,
    handleChangeCurrency,
    handleAmountChange,
    selectedMethodName: data?.withdraw_method,
    isSelectedAmountOrNote: "amount",
  };

  const { sendCalculations } = useSendButtonCalculation({
    amount: currentAmount,
    currency: currencyFromDecode,
    balance,
    minTransactionAmt,
    maxTransactionAmt,
    sendMaxAmount,
    showBtcAmount,
    networkFeeAmount,
    calculatedSpeedFees,
    isLnUrlMethodReceive,
    isLnUrlMethodSend,
    isEthereumMethod,
    isTronMethod,
    isLightningMethod,
    isOnchainMethod,
    // setButtonColor,
  });

  const handleSend = () => {
    setAmount(currentAmount);
    setIsOpen(false);
  };

  return (
    <CommonDrawer
      anchor="bottom"
      open={isOpen}
      onClose={handleDrawerClose}
      className="mini-app-enter-amount-drawer"
    >
      <Box className="mini-app-amount-wrapper">
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Text className="default-text" size={20} font="semibold">
            {enterAmount}
          </Text>
          <CloseIcon
            sx={{
              color: "#848B9E",
              height: "24px",
              width: "24px",
              cursor: "pointer",
            }}
            onClick={handleDrawerClose}
          />
        </Box>

        <Box className="mini-app-amount-box">
          <EnterAmountBox {...enterAmountBoxProps} />

          <KeyboardDoubleArrowDownOutlinedIcon
            sx={{
              color: "#2A67FF",
              margin: "7px 0px",
            }}
          />
          {isLnUrlMethodSend ? (
            <Text
              className="grey-text"
              size={14}
              font="regular"
              sx={{
                width: "300px",
                whiteSpace: "nowrap",
                textAlign: "center",
                display: "flex",
                gap: "5px",
                justifyContent: "center",
              }}
            >
              {payToTxt}
              <div
                style={{
                  width: "154px",
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                  color: "#0a193e",
                }}
              >
                <MiddleEllipsis>
                  <span>{displayAddress}</span>
                </MiddleEllipsis>
              </div>
            </Text>
          ) : (
            <div
              style={{
                width: "300px",
                whiteSpace: "nowrap",
                fontWeight: "bold",
                color: "#0a193e",
                textAlign: "center",
              }}
            >
              <MiddleEllipsis>
                <span>{displayAddress}</span>
              </MiddleEllipsis>
            </div>
          )}
        </Box>

        <Button
          fullWidth
          variant="contained"
          label={sendCalculations?.btnLabel}
          onClick={handleSend}
          disabled={sendCalculations?.btnDisable}
        />
      </Box>
    </CommonDrawer>
  );
}

export default EnterAmountMiniApp;
